import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import FiltersModal from '@commons/DeepsightAnalyticsHeaders/components/DeepsightFiltersButton/components/FiltersModal';

import { FiltersContainer, IconActive } from './styledComponents';

function DeepsightFiltersButton(props) {
  const { readOnly, textFilterButton, advancedFilters } = props;

  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    // If advanced filters are set and at least one of them has display set to true and a value, display active filter icon
    setIsFilterActive(
      !isEmpty(advancedFilters) &&
        advancedFilters.some(({ display, value }) => display && _checkAdvancedFiltersValue(value)),
    );
  }, [advancedFilters]);

  /**
   * Check advanced filter's value.
   * Any number is valid, and any string or array whose length is greater than 0.
   *
   * @param {string|number|Array} value
   *
   * @returns {boolean}
   * @private
   */
  const _checkAdvancedFiltersValue = (value) => typeof value === 'number' || value.length > 0;

  return (
    <FiltersContainer>
      <Button
        color="inpulse-filter"
        fontSize={14}
        formatText={false}
        handleClick={() => {
          if (readOnly) {
            return;
          }

          setFiltersModalOpen(!filtersModalOpen);
        }}
        height={40}
        icon={'/images/inpulse/filter-black-small.svg'}
        isActive={filtersModalOpen}
        isDisabled={readOnly}
        label={textFilterButton}
        maxWidth={240}
        minWidth={240}
      />
      {isFilterActive && (
        <IconActive
          alt="icon-filter-active"
          readOnly={readOnly}
          src={
            readOnly
              ? '/images/icon-dot-active-grey-inpulse.svg'
              : '/images/icon-dot-active-green-inpulse.svg'
          }
        />
      )}
      {filtersModalOpen && (
        <FiltersModal
          params={props}
          setFiltersModalOpen={setFiltersModalOpen}
          setIsFilterActive={setIsFilterActive}
        />
      )}
    </FiltersContainer>
  );
}

DeepsightFiltersButton.propTypes = {
  readOnly: PropTypes.bool,
  textFilterButton: PropTypes.string.isRequired,
};

DeepsightFiltersButton.defaultProps = {
  readOnly: false,
};

export default DeepsightFiltersButton;
